import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import moment from 'moment';
import { IOfferTimeRange } from '../../../types/IItemSetup';
import DateField from '../../DateField/DateField';
import { convertSecondsToTime } from '../../PreOrders/Utils';
import {
  commonDateFormat,
  getDaysBetween,
  getNegotiatingStartDate,
  IFilterOptions,
  IShowNoDate,
} from './createDatesUtils';

interface IOfferDatesRow {
  filterOptions: IFilterOptions;
  showNoDate: IShowNoDate;
  disabledDates: any;
  offeringTimeRange: IOfferTimeRange;
  daysToFinalize: number;
  setOfferStartDate: (val: any) => void;
  setOfferEndDate: (val: any) => void;
}

const OfferDatesRow = forwardRef(
  (
    {
      filterOptions,
      showNoDate,
      disabledDates,
      offeringTimeRange,
      daysToFinalize,
      setOfferStartDate,
      setOfferEndDate,
    }: IOfferDatesRow,
    ref: any
  ) => {
    const offerStartDateRef = useRef<any>();
    const offerEndDateRef = useRef<any>();

    useImperativeHandle(ref, () => ({
      showError: (error: string) => {
        if (offerStartDateRef?.current?.showError) offerStartDateRef.current.showError(error);
        if (offerEndDateRef?.current?.showError) offerEndDateRef.current.showError(error);
      },
    }));

    const startTakingOffersLabel = `Start Taking Offers (${convertSecondsToTime(
      offeringTimeRange?.offerStartTimeInSeconds ?? 0,
      'hh:mm a'
    )})`;
    const endTakingOffersLabel = `End Taking Offers (${convertSecondsToTime(
      offeringTimeRange?.offerEndTimeInSeconds ?? 0,
      'hh:mm a'
    )})`;
    const offeringDays = !showNoDate.offerEnd
      ? getDaysBetween(
          filterOptions.offerDates?.startDate,
          getNegotiatingStartDate(filterOptions.offerDates?.endDate, offeringTimeRange)
        )
      : '--';

    return (
      <div className="grid-x small-12  margin-bottom-2 px-create-date-filter-selector-container">
        <div className="cell small-2 create-dates-labels">Offering ({offeringDays}D):</div>
        <DateField
          textfieldProps={{
            variant: 'outlined',
            label: !showNoDate.offerStart && startTakingOffersLabel,
            placeholder: showNoDate.offerStart ? startTakingOffersLabel : '',
            InputLabelProps: { shrink: true },
          }}
          disabled={{
            before: moment().format(commonDateFormat),
            after: !showNoDate.offerEnd
              ? moment(disabledDates?.offerDates?.after, commonDateFormat)
              : undefined,
          }}
          date={filterOptions?.offerDates?.startDate}
          setDate={setOfferStartDate}
          ref={offerStartDateRef}
          showNoDate={showNoDate.offerStart}
        />
        to
        <DateField
          textfieldProps={{
            variant: 'outlined',
            label: !showNoDate.offerEnd && endTakingOffersLabel,
            placeholder: showNoDate.offerEnd ? endTakingOffersLabel : '',
            disabled: showNoDate.offerStart,
            InputLabelProps: { shrink: true },
          }}
          disabled={{
            before: moment(filterOptions?.offerDates?.startDate, commonDateFormat),
            after: !showNoDate.shippingStart
              ? moment(filterOptions?.shippingDates?.startDate, commonDateFormat).subtract(
                  daysToFinalize + 2,
                  'day'
                )
              : undefined,
          }}
          date={filterOptions?.offerDates?.endDate ?? ''}
          setDate={setOfferEndDate}
          ref={offerEndDateRef}
          showNoDate={showNoDate.offerEnd}
        />
      </div>
    );
  }
);

export default OfferDatesRow;
